const HorizonalLine = ({ color, ...props }) => {
  return (
    <hr style={{ width: '100%', color: color || 'grey' }} {...props} />
  )
}

export default HorizonalLine
